import animate from './animate';

/**
 * Scroll an HTML element in to view
 * Opinionated - will scroll the element to the viewport (window) center
 * @param {HTMLElement} element the HTML element to calculate position
 * @param {Function} onStart the callback when animation starts
 * @param {Function} onComplete the callback when animation completes
 */
/* istanbul ignore next */
export const scrollIntoView = async <T extends HTMLElement = HTMLElement>(
  element?: T | null,
  onStart: () => void = () => {},
  onComplete: () => void = () => {}
): Promise<string> => {
  return new Promise((resolve, reject) => {
    const timer = setTimeout(() => {
      reject(new Error('animation timed out'));
    }, 5000);

    if (!element) return;
    const rect = element.getBoundingClientRect();
    const toValue =
      rect.top + window.scrollY - window.innerHeight / 2 + Math.min(rect.height, window.innerHeight - 30) / 2;

    animate({
      fromValue: window.scrollY,
      toValue,
      onStart,
      onUpdate: (scrollTop: number, next: () => void) => {
        window.scrollTo({ left: 0, top: scrollTop });
        next();
      },
      onComplete: () => {
        clearTimeout(timer);
        onComplete();
        resolve('animation complete');
      },
    });
  });
};

export default scrollIntoView;
